<div id="rrhh-archives-container">
  <!-- Top block -->
  <div id="top-block">
    <p class="heading-02-semi-bold grey-900 title">Archivos</p>
    <!-- Archivos -->
    <div class="row-container">
      <div id="files-container">
        <input
          hidden
          type="file"
          multiple="false"
          #uploader
          (change)="addFile($event)"
        />
        <qr-button
          id="add"
          [config]="buttonAddFile"
          (click)="uploader.click()"
        ></qr-button>
        <p class="paragraph-03-regular grey-700">
          Curriculum Vitae, Psicotécnico, otros.
        </p>
      </div>
      <div class="item-container right">
        <p class="paragraph-02-regular grey-700">
          Te recomendamos utilizar formato <br />
          <strong>PDF</strong>.
        </p>
        <br />
        <p class="paragraph-02-regular grey-700">
          Archivos soportados hasta 5 MB.
        </p>
        <!-- Error contenedor -->
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.file }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            {{ this.fileErrorMessage }}
          </p>
        </div>
      </div>
    </div>
    <!-- Archivos -->
  </div>
  <!-- Top block -->

  <!-- Top bottom -->
  <div id="bottom-block">
    <!-- Listado de archivos -->
    <div id="files-list-container">
      <app-table-header-new
        class="table-header"
        [tableHeader]="tableHeaderFiles"
        [isCheckboxColumnVisible]="false"
      ></app-table-header-new>
      <ng-container
        *ngIf="this.filesList && this.filesList.length > 0; else emptyfiles"
      >
        <div
          class="file-item"
          *ngFor="let item of this.filesList; let i = index"
          [ngClass]="{ 'color-1': i % 2 == 0 }"
        >
          <p
            matTooltip="{{ item.file }}"
            class="font-files grey-700"
            [ngClass]="{ 'ec-width-file-name': !this.isArgAndDo }"
            *ngIf="item.file && item.file.length > 29; else namefull"
          >
            {{ utilsService.truncateString(item.file, 28) }}
          </p>
          <ng-template #namefull>
            <p
              class="font-files grey-700"
              [ngClass]="{ 'ec-width-file-name': !this.isArgAndDo }"
            >
              {{ item.file }}
            </p>
          </ng-template>
          <ng-container *ifNodeHide="[NODE_DO, NODE_AR]">
            <p
              class="font-files grey-700"
              [ngClass]="{ 'ec-width-file-p': !this.isArgAndDo }"
            >
              {{ item.date | date : "dd/MM/yyyy" }}
            </p>
            <p
              class="font-files grey-700"
              [ngClass]="{ 'ec-width-file-p': !this.isArgAndDo }"
            >
              {{ item.user }}
            </p></ng-container
          >
          <ng-container *ifNodeShow="[NODE_DO, NODE_AR]">
            <div class="dropdown-document-types">
              <qr-dropdown
                [selected]="item.type"
                (change)="changeDocumentType($event, item.file)"
                class="dropdown"
                [config]="this.dropdownDocumentTypes"
                [hasError]="!item.type && this.NODE === this.NODE_AR"
              ></qr-dropdown>
            </div>

            <qr-icon
              class="help-icon"
              [matTooltip]="
                'Usuario: ' +
                item.user +
                '. \n\nFecha de subida: ' +
                (item.date | date : 'd/M/y')
              "
              name="question-mark"
              color="grey-600"
              matTooltipClass="custom-tooltip"
            ></qr-icon>
          </ng-container>

          <qr-button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            [config]="kebabButtonConfig"
            class="button-menu"
          ></qr-button>
          <!-- Menu Options -->
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="deleteFile(item.name)">
              <div class="menu-files">
                <qr-icon name="delete" color="grey-600"></qr-icon>
                <p class="subheading-01-semi-bold">Borrar</p>
              </div>
            </button>
            <button mat-menu-item (click)="downloadFile(item.path, item.name)">
              <div class="menu-files">
                <qr-icon name="download" color="grey-600"></qr-icon>
                <p class="subheading-01-semi-bold">Descargar</p>
              </div>
            </button>
          </mat-menu>
          <!-- Menu Options -->
        </div>
      </ng-container>
      <ng-template #emptyfiles>
        <div id="empty-container">
          <p class="subheading-01-semi-bold">No hay archivos subidos</p>
        </div>
      </ng-template>
    </div>
    <!-- Listado de archivos -->
  </div>
  <!-- Top bottom -->
</div>
